import { render, staticRenderFns } from "./SbFooter.vue?vue&type=template&id=2d8a0b17&scoped=true"
import script from "./SbFooter.vue?vue&type=script&lang=js"
export * from "./SbFooter.vue?vue&type=script&lang=js"
import style0 from "./SbFooter.vue?vue&type=style&index=0&id=2d8a0b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a0b17",
  null
  
)

export default component.exports